var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade modal-select",
          attrs: { id: "modalSelectVoucherType" }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "center-modal" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "font300 d-flex justify-content-center titl-modal-select"
                    },
                    [
                      _c("span", { staticClass: "fs-20" }, [
                        _c("span", { staticClass: "font500" }, [
                          _vm._v(_vm._s(_vm.$t("voucher.general.voucher_type")))
                        ]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("voucher.general.select")) +
                            "\n                            "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.screenType == _vm.Constants.CashScreenType
                    ? _c("div", { staticClass: "content-modal-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.receipt_carry_cash.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.receipt_carry_cash
                                    .id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.receipt_carry_cash
                                      .name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType
                                  .use_biz_pre_paid_card_cash.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType
                                    .use_biz_pre_paid_card_cash.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType
                                      .use_biz_pre_paid_card_cash.name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.carry_cash_other.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.carry_cash_other.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.carry_cash_other
                                      .name
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.screenType == _vm.Constants.LocalIncomeScreenType
                    ? _c("div", { staticClass: "content-modal-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType
                                  .receipt_local_placement_income.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType
                                    .receipt_local_placement_income.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType
                                      .receipt_local_placement_income.name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType
                                  .local_placement_income_other.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType
                                    .local_placement_income_other.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType
                                      .local_placement_income_other.name
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.groupType == _vm.Constants.GroupVoucherType.invoice_bill
                    ? _c("div", { staticClass: "content-modal-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.invoice_bill.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.invoice_bill.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.invoice_bill.name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.invoice_invoice.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.invoice_invoice.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.invoice_invoice
                                      .name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.invoice_bill_other.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.invoice_bill_other
                                    .id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.invoice_bill_other
                                      .name
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.groupType == _vm.Constants.GroupVoucherType.contract
                    ? _c("div", { staticClass: "content-modal-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.contract_document.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.contract_document.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.contract_document
                                      .name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.contract_outsourcing
                                  .id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.contract_outsourcing
                                    .id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType
                                      .contract_outsourcing.name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType.contract_other.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType.contract_other.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType.contract_other
                                      .name
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.groupType ==
                  _vm.Constants.GroupVoucherType.local_expense_voucher
                    ? _c("div", { staticClass: "content-modal-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType
                                  .local_expense_voucher_carry_cash.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType
                                    .local_expense_voucher_carry_cash.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType
                                      .local_expense_voucher_carry_cash.name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "center-ttl font300 d-flex justify-content-center",
                            class: {
                              active:
                                _vm.voucherType ==
                                _vm.Constants.VoucherType
                                  .local_expense_voucher_receipt.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectType(
                                  _vm.Constants.VoucherType
                                    .local_expense_voucher_receipt.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "fs-20",
                                attrs: { href: "javascript:void(0);" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.Constants.VoucherType
                                      .local_expense_voucher_receipt.name
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.Utils.isEmptyObj(_vm.tourInfo) ||
                        _vm.tourInfo.tour_type ==
                          _vm.Constants.TourType.international.id
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "center-ttl font300 d-flex justify-content-center",
                                class: {
                                  active:
                                    _vm.voucherType ==
                                    _vm.Constants.VoucherType
                                      .currency_exchange_receipt.id
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectType(
                                      _vm.Constants.VoucherType
                                        .currency_exchange_receipt.id
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "fs-20",
                                    attrs: { href: "javascript:void(0);" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.Constants.VoucherType
                                          .currency_exchange_receipt.name
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.Utils.isCooperator()
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "center-ttl font300 d-flex justify-content-center",
                                class: {
                                  active:
                                    _vm.voucherType ==
                                    _vm.Constants.VoucherType
                                      .local_expense_voucher_other.id
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectType(
                                      _vm.Constants.VoucherType
                                        .local_expense_voucher_other.id
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "fs-20",
                                    attrs: { href: "javascript:void(0);" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.Constants.VoucherType
                                          .local_expense_voucher_other.name
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-4 no-gutters g-btn-select" },
                    [
                      _c("div", { staticClass: "col-6 pr-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-pink-53 fs-18 w-100",
                            attrs: {
                              disabled: _vm.isDisabledSubmit,
                              "data-toggle": "modal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.addVoucher()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.ok")))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 pl-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-gray-53 fs-18 w-100",
                            attrs: { "data-dismiss": "modal" }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("select-contract-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68bb8042", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68bb8042","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Voucher/SelectVoucherTypeModal.vue
// module id = null
// module chunks = 